const moment = require("moment");

class StaticFunctions {

    static noOp() {

        //  Leer-Funktion für Default-Callbacks...

    }

    static getJsonParse(item, defaultVal = false) {

        item = (typeof item !== 'string') ? JSON.stringify(item) : item;

        try {
            item = JSON.parse(item);
        } catch (e) {
            return defaultVal;
        }

        return (typeof item === 'object' && item !== null) ? item : defaultVal;

    }

    static getSortedData(data, column, sortType = 'string', dateTimeFormat = 'm-DD-YYYY HH:mm', order = 'asc') {

        const rgxFormat = /[.]/g;
        const rows = [].concat(data);

        if (column && sortType) {
            rows.sort((a, b) => {
                let tempA = (a[column] !== undefined) ? a[column] : '';
                let tempB = (b[column] !== undefined) ? b[column] : '';
                let compareResult;

                switch (sortType) {
                    case 'string':
                        if (typeof tempA === 'string' && typeof tempB === 'string') compareResult = tempA.toLowerCase().localeCompare(tempB.toLowerCase());
                        break;

                    case 'int':
                    case 'number':
                        //if(Number.isNaN(tempA) || Number.isNaN(tempB)) {
                        if(typeof tempA === 'string' && typeof tempB === 'string') {
                            compareResult = parseInt(tempA.replace(rgxFormat, '')) - parseInt(tempB.replace(rgxFormat, ''));
                        } else {
                            compareResult = parseInt(tempA) - parseInt(tempB);
                        }
                        break;

                    case 'float':
                        compareResult = parseFloat(tempA.replace(',', '.')) - parseFloat(tempB.replace(',', '.'));
                        break;

                    case 'date':
                    case 'datetime':
                    case 'time':
                        let compareA = StaticFunctions.getTimestampFromDate(tempA, dateTimeFormat);
                        let compareB = StaticFunctions.getTimestampFromDate(tempB, dateTimeFormat);

                        compareResult = ((Number.isNaN(compareA)) ? 0 : compareA) - ((Number.isNaN(compareB)) ? 0 : compareB);
                        break;

                    case 'children':
                        if (typeof tempA === 'object' && typeof tempB === 'object') {
                            if (tempA.props && tempA.props[sortType] && tempB.props && tempB.props[sortType]) {
                                if (typeof tempA.props[sortType] === 'string' && typeof tempB.props[sortType] === 'string') compareResult = tempA.props.children.localeCompare(tempB.props.children);
                            }
                        }
                        break;

                    default:
                        compareResult = 0;
                        break;
                }

                return (order.toLowerCase() === "desc") ? compareResult * -1 : compareResult;
            });
        }

        return rows;

    }

    static getFilteredData(data, needle, fields = [], caseInsensitive = true) {

        if (!needle) return data;

        const filteredData = [];
        const searchStr = (caseInsensitive) ? needle.toLowerCase() : needle;

        for (let i = 0; i < data.length; i++) {
            let dataRows = data[i];

            for(let j in dataRows) {
                if (fields.length === 0 || fields.includes(j)) {
                    let dataRow = (dataRows[j] && caseInsensitive) ? dataRows[j].toLowerCase() : dataRows[j];

                    if (dataRow && dataRow.indexOf(searchStr) !== -1) {
                        filteredData.push(dataRows);

                        break;
                    }
                }
            }
        }

        return filteredData;
    }

    static getUniqueArray(array) {

        if (!Array.isArray(array)) return [];

        return array.filter(function (value, index, self) {
            return self.indexOf(value) === index;
        });

    }

    static getSelectOptionsFromArray(array, valueKey = 'id', labelKey = 'name') {

        if (!Array.isArray(array) || !valueKey || !labelKey) return null;
        if (array.length === 0) return [];

        return array.map(
            (obj) => {
                return {
                    value: obj[valueKey],
                    label: obj[labelKey]
                };
            }
        );

    }

    static isDate(str) {

        const defaultFormats = StaticFunctions.getDefaultTimeFormats();

        let isDate = false;

        for (let key in defaultFormats) {
            const format = defaultFormats[key];

            if (moment(str, format, true).isValid()) {
                isDate = true;

                break;
            }
        }

        return isDate;

    }

    static getCurrentDate(format = 'YYYY-MM-DD') {

        return moment().format(format);

    }

    static getTimestampFromDate(date, format = 'm-DD-YYYY HH:mm') {

        if (!date) return 0;

        let m = moment(date, format);

        return m.unix();

    }

    static getGmtFromTimezoneString(timezoneString) {

        if (timezoneString === 'Canada/East-Saskatchewan') return 'GMT-6';
        if (!timezoneString || !moment.tz.zone(timezoneString)) return null;
        if (timezoneString.includes('GMT+') || timezoneString.includes('GMT-') || timezoneString.includes('GMT0')) return null;

        let utcOffset = moment.tz.zone(timezoneString).utcOffset(Date.now());
        let utcValue = utcOffset / 60 * -1;
        let sign = (utcValue >= 0) ? '+' : '';

        return 'GMT' + sign + utcValue;

    }

    static getSecurityLevelOfPassword(password, passwordMinLength = 12) {

        let securityLevel = 0;

        //  Password is to short, securityLevel = 0.
        if (password.length >= passwordMinLength) {
            if (password.match(/[A-ZÄÖÜ]{1,}/)) securityLevel++;                                    //  If password contains capital letters, securityLevel + 1.
            if (password.match(/[a-zäöü]{1,}/)) securityLevel++;                                    //  If password contains lowercase letters, securityLevel + 1.
            if (password.match(/\d{1,}/)) securityLevel++;                                          //  If password contains numbers, securityLevel + 1.
            if (password.match(/\W/) || password.match(/[$-/:-?{-~!"^_`\[\]]/)) securityLevel++;    //  If password contains symbols, securityLevel + 1.
        }

        return securityLevel;

    }

    static getSecurityColorFromLevel(securityLevel) {

        const securityColors = ['#f9f9f9', '#ff352c', '#ff9410', '#fff635', '#6ca413'];

        return securityColors[securityLevel];

    }

    static validateEmail(email) {

        const reg = /^(?:[a-zA-Z0-9!#$%&amp;'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&amp;'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;

        return reg.test(String(email).toLowerCase());

    }

    static validateVatNumber(vat, isRequired = true) {

        if (!vat) {
            return !(isRequired === true);
        }

        const countryCode = String(vat).substring(0, 2).toUpperCase();
        const uniqueNumber = String(vat).substring(2, String(vat).length).toUpperCase();
        const mapping = {
            AT: /^U[0-9]{8}$/,                              //  Austria
            BE: /^0[0-9]{9}$/,                              //  Belgium
            BG: /^[0-9]{9,10}$/,                            //  Bulgaria
            CY: /^[0-9]{8}L$/,                              //  Cyprus
            CZ: /^[0-9]{8,10}$/,                            //  Czech Republic
            DE: /^[0-9]{9}$/,                               //  Germany
            DK: /^[0-9]{8}$/,                               //  Denmark
            EE: /^[0-9]{9}$/,                               //  Estonia
            EL: /^[0-9]{9}$/,                               //  Greece
            GR: /^[0-9]{9}$/,                               //  Greece
            ES: /^[0-9A-Z][0-9]{7}[0-9A-Z]$/,               //  Spain
            FI: /^[0-9]{8}$/,                               //  Finland
            FR: /^[0-9A-Z]{2}[0-9]{9}$/,                    //  France
            GB: /^([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})$/, //  United Kingdom
            HR: /^[0-9]{11}$/,                              //  Croatia
            HU: /^[0-9]{8}$/,                               //  Hungary
            IE: /^[0-9]S[0-9]{5}L$/,                        //  Ireland
            IT: /^[0-9]{11}$/,                              //  Italy
            LT: /^([0-9]{9}|[0-9]{12})$/,                   //  Lithuania
            LU: /^[0-9]{8}$/,                               //  Luxembourg
            LV: /^[0-9]{11}$/,                              //  Latvia
            MT: /^[0-9]{8}$/,                               //  Malta
            NL: /^[0-9]{9}B[0-9]{2}$/,                      //  Netherlands
            PL: /^[0-9]{10}$/,                              //  Poland
            PT: /^[0-9]{9}$/,                               //  Portugal
            RO: /^[0-9]{2,10}$/,                            //  Romania
            SE: /^[0-9]{12}$/,                              //  Sweden
            SI: /^[0-9]{8}$/,                               //  Slovenia
            SK: /^[0-9]{10}$/,                              //  Slovakia
            SM: /^[0-9]{3,5}$/,                             //  San Marino
        };

        let reg = '';

        if (mapping.hasOwnProperty(String(countryCode))) reg = mapping[countryCode];

        return (reg) ? reg.test(String(uniqueNumber)) : false;

    }

    static validateVatNumberSave(vat) {

        /*
            # Austria           (AT)?U[0-9]{8}
            # Belgium           (BE)?0[0-9]{9}
            # Bulgaria          (BG)?[0-9]{9,10}
            # Cyprus            (CY)?[0-9]{8}L
            # Czech Republic    (CZ)?[0-9]{8,10}
            # Germany           (DE)?[0-9]{9}
            # Denmark           (DK)?[0-9]{8}
            # Estonia           (EE)?[0-9]{9}
            # Greece            (EL|GR)?[0-9]{9}
            # Spain             (ES)?[0-9A-Z][0-9]{7}[0-9A-Z]
            # Finland           (FI)?[0-9]{8}
            # France            (FR)?[0-9A-Z]{2}[0-9]{9}
            # United Kingdom    (GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})
            # Hungary           (HU)?[0-9]{8}
            # Ireland           (IE)?[0-9]S[0-9]{5}L
            # Italy             (IT)?[0-9]{11}
            # Lithuania         (LT)?([0-9]{9}|[0-9]{12})
            # Luxembourg        (LU)?[0-9]{8}
            # Latvia            (LV)?[0-9]{11}
            # Malta             (MT)?[0-9]{8}
            # Netherlands       (NL)?[0-9]{9}B[0-9]{2}
            # Poland            (PL)?[0-9]{10}
            # Portugal          (PT)?[0-9]{9}
            # Romania           (RO)?[0-9]{2,10}
            # Sweden            (SE)?[0-9]{12}
            # Slovenia          (SI)?[0-9]{8}
            # Slovakia          (SK)?[0-9]{10}
         */
        const reg = /^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?DE[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$/;

        return reg.test(String(vat));

    }

    static validatePassword(pw, confirmPw) {

        const minLength = 12;
        const minSecurityLevel = 3;

        const password = pw || '';
        const confirmPassword = confirmPw || '';

        let status = true;

        if (!password) {
            status = 'errorNewPasswordUnset';
        } else if (password.length < minLength) {
            status = 'errorNewPasswordToShort';
        } else if (StaticFunctions.getSecurityLevelOfPassword(password, minLength) < minSecurityLevel) {
            status = 'errorNewPasswordUnsure';
        } else if (!confirmPassword) {
            status = 'errorNewPasswordNotConfirmed';
        } else if (password !== confirmPassword) {
            status = 'passwordsDontMatch';
        }

        return status;

    }

    static validateRequiredFields(formFields, requiredFields = []) {

        const errorFields = StaticFunctions.checkRequiredFields(formFields, requiredFields);

        return (errorFields.length === 0);

    }

    static checkRequiredFields(formFields, requiredFields = []) {

        if (Object.keys(formFields).length === 0 || requiredFields.length === 0) return true;

        let errorFields = [];

        for (let key in requiredFields) {
            let fieldName = requiredFields[key];

            //  Sollte der Inputname in formFields nicht existieren, oder dessen Wert undefined, ein Leerstring oder false sein, ist dieser ungültig.
            //if (!formFields.hasOwnProperty(fieldName) || typeof formFields[fieldName] === 'undefined' || formFields[fieldName] === '' || formFields[fieldName] === false) {
            if (!formFields.hasOwnProperty(fieldName) || !formFields[fieldName]) {
                errorFields.push(fieldName);
            }
        }

        return errorFields;

    }

	static getValueOfPropByKey(data, value, key = 'id', prop = 'value', defaultValue = null) {

		let result = defaultValue;

		for (let i in data) {
			const row = data[i];

			if (row && row.hasOwnProperty(prop) && row.hasOwnProperty(key) && row[key] === value) {
				result = row[prop];
				break;
			}
		}

		return result;

	}

    static getDataByColumnKey(data, key) {

        const result = [];

        for (let i in data) {
            const dataTemp = data[i];

            if (dataTemp[key] !== undefined) result.push(dataTemp[key]);
        }

        return result;

    }

    static substringExists(haystack, needle) {

        if (haystack === null || haystack === '' || needle === null || needle === '') return false;
        //if (haystack === '' || needle === '') return true;
        //if (haystack === null || needle === null) return false;
        if (haystack.length < needle.length) return false;

        const haystackStr = (haystack) ? haystack.toString() : '';
        const needleStr = (needle) ? needle.toString() : '';
        const result = haystackStr.toLowerCase().indexOf(needleStr.toLowerCase());

        return (result >= 0);

    }

    static calcThreadbreaksByRatio(st, tb, ratio = 10000, toFixed = 2) {

        return ((st > 0 && tb > 0 && ratio > 0 && toFixed >= 0) ? (Math.round(tb * ratio * Math.pow(10, toFixed) / st) / Math.pow(10, toFixed)) : 0).toFixed(toFixed);

    }

    static getDefaultTimeFormats() {

        return {
            fullDate: 'DD.MM.YYYY',
            monthYear: 'MM.YYYY',
            fullTime: 'HH:mm:ss',
            hourMinute: 'HH:mm',
            datetime: 'DD.MM.YYYY HH:mm'
        };

    }

    static getTimeFormatString(formats, key) {

        if (!formats || !key) return null;

        const defaultFormats = StaticFunctions.getDefaultTimeFormats();

        if (formats[key]) {
            return formats[key];
        } else if (defaultFormats[key]) {
            return defaultFormats[key];
        } else {
            return null;
        }

    }

    static formatedNumber(number, toFixed = 0, seperator = '.', decimal = ',') {

        if (!Number.isInteger(toFixed)) return number;

        const splitedNumber = parseFloat(number).toFixed(toFixed).toString().split('.');

        let formattedNumber = splitedNumber[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, seperator);

        if (splitedNumber[1]) formattedNumber += decimal + splitedNumber[1];

        return formattedNumber;

    }

    static convertSecondsToFormatedString(totalSeconds, showHours = false) {

        if (totalSeconds === null) return (showHours) ? '--:--:--' : '--:--';

        totalSeconds = Math.floor(totalSeconds);

        //const days = Math.floor(totalSeconds / (60 * 60 * 24));
        //totalSeconds %= (60 * 60 * 24);

        const hours = Math.floor(totalSeconds / (60 * 60));
        totalSeconds %= (60 * 60);

        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        let formatedString = '';

        //if (days > 0) formatedString += StaticFunctions.leadingZero(days) + ' ';
        //if (showHours || hours > 0) formatedString += StaticFunctions.leadingZero(hours) + ':';

        formatedString += ((parseInt(hours) > 24)) ? StaticFunctions.formatedNumber(hours) : StaticFunctions.leadingZero(hours);
        formatedString += ':';
        formatedString += StaticFunctions.leadingZero(minutes);
        formatedString += ':';
        formatedString += StaticFunctions.leadingZero(seconds);

        return formatedString;

    }

    static addThousandsSeparator(number) {

        if (!number) return 0;

        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    }

    static convertPointToComa(number) {

        if (!number) return number;

        return number.replace('.', ',');

    }

    static leadingZero(int) {

        return ((parseInt(int) < 10) ? '0' : '') + parseInt(int);

    }

    static findSubstringInObjArray(array, substring, props){

        if (!array || !substring || array.length === 0) return array;

        props = (typeof props !== 'undefined') ? props : Object.getOwnPropertyNames(array[0]);

        return array.filter((obj) => {
            return props.some((prop) => {
                return (obj[prop] && obj[prop].toLowerCase().indexOf(substring.toLowerCase()) !== -1);
            });
        });

    }

    static findObjectInArray(array, key, value) {

        if (!Array.isArray(array) || !key) return null;
        if (array.length === 0) return null;

        const result = array.find((obj) => String(obj[key]) === String(value));

        return (typeof result !== 'undefined') ? result : null;

    }

    static filterObjectsInArray(array, keys = [], values = []) {

        if (!(Array.isArray(array) && Array.isArray(keys) && Array.isArray(values))) return [];
        if (array.length === 0 || keys.length !== values.length) return [];

        return array.filter((obj) => {
            return keys.every((key, ix) => {
                return (obj.hasOwnProperty(key) && String(obj[key]) === String(values[ix]));
            });
        });

    }

    static arrayMapObjectToProperty(array, key) {

        if (!Array.isArray(array) || !key) return null;
        if (array.length === 0) return [];

        return array.map((obj) => obj[key]).filter((obj) => !!obj);

    }

    static getSumOfArray(array) {

        if (!Array.isArray(array)) return null;
        if (array.length === 0) return 0;

        return array.reduce((a, c) => a + +c, 0);

    }

    static getAvgOfArray(array) {

        if (!Array.isArray(array)) return null;
        if (array.length === 0) return 0;

        return array.reduce((a, c) => +a + +c, 0) / array.length;

    }

    static getMinOfArray(array) {

        if (!Array.isArray(array)) return null;
        if (array.length === 0) return 0;

        return Math.min(...array);

    }

    static getMaxOfArray(array) {

        if (!Array.isArray(array)) return null;
        if (array.length === 0) return 0;

        return Math.max(...array);

    }

    static getDownloadFilename(moment, name) {

        return moment.get('year') + '-' + StaticFunctions.leadingZero(moment.get('month') + 1) + '-' + StaticFunctions.leadingZero(moment.get('day')) + ' - ' + name;

    }

    static getImgQuestionMarkSrc() {

        return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3gQXDjEDiWRlGwAAAB1pVFh0Q29tbWVudAAAAAAAQ3JlYXRlZCB3aXRoIEdJTVBkLmUHAAAWxElEQVR42u2d2XMbV3bGf92NxkqAWEgQIikKFGWSJkWJsihZsuVFlseeZDx5ykOSyp+WSlWSt6SSzMTx1NjWRKNtyqY2a+dOiRQXcAFI7Gigu/PQ4A6gGxRpe6Z0qlAlEY1G99fnnvOd7557Iei6rvPGDt3ENxC8AfoN0G+sfrP9nC9O0zRUVUXTNHRdZ3c6EQQBQRAQRRFRFJEk6Q3QVkxVVVKpFOl0mkwmQzabJZfLUSgUUBRlE3RgE1y73Y7dbsflcuF2u/F4PDQ0NOD1epFl+Q3Q221hYYHZ2VkSicQOUK1ZbmcsFMFud+Nw+PB6vbS3t3P06FFE8aeNksJPRe9yuRxjY2NMTExQKpX2exaT952AEV6OHTtGb28vjY2Nf/lAF4tFkskkY2NjzMzMvO6jMsnn2rZ/uzb/FQ6H6e3tJRgM4nA4/vKAnp+fZ3Jykvn5+YMaExaIU2WwAZqbm4lGo3R2diIIwp8/0LlcjuHhYZaXl+uIu1aBthJ3q4MtiiJ+v59z587h9/v/PIHWNI3Z2Vnu3LlzwADX49GVAHdVfLe/v5+333770CjioQCdzWZ5/vw5ExMThzlWDhRogJaWFgYHBw/Fuw8c6FgsxsOHD0kkEocC74bHaVoa48rroW1aTaAB3G43AwMDRKPRny/Qc3NzDA8PoyjKa5/L5/MRDocJBoM0NjbidDq3ceESjP0OvZil4BRJAokSLC/D6qoZ0AblM3uYvb29nDx58ucH9Pz8PDdv3tx/5WSzEQgEiEajtB8JYs8sGW/IbmgIg2Tf+YGpP0LiBciAJO6Ach54kYClJSiVYOsOtfIIsEbrBgYG6OnpOZC4fSBAT09PMzw8vK/PBoNBIpEI0WgUb3oSlsegmN0lfdmgsR3ahsDRYPxtdQJe3DJws1cOH3lgBphbgqUl8xhdLUkehGe/NtBTU1Pcu3dvU4Owal6vl/7+fsLhMC41ZXjodoDFCuxMssOx9yAQBVWBR/8OWgmcteO0AqwqGqPrEItVA7qw68sA7IBEd3c3Z86c+emAXl5e5saNG3WX0H19ffT19RlDcv2VAbJWPodd3JHfssAisK5oZLNQLIqIYhSn04nbHSdQWKTJLuIwy4l5DVUQeem/VMExapXyLkRRZGBggN7e3h8f6FwuxzfffEM+n6/Liy9evEggEDD+EJ8yhr+ubYYArQzuHDA+DZlMJYq2Pc7myslT5HgHtJeDww7cFc34aOgERC+Ry+W4ffs2q6vzu85ZnRLabDYuXbpES0vLjwe0qqpcu3aN1dopfodFo1FOnz6N0+ksj9Q0PPuN4cnlhJYFJjWYnIRCwYwPb7CHnXzabofjx6HLBg0AqgbFcth5+2+Mh/ryFnp6iSfAyBRomlkZb4Qbj8fDlStXcLlcPw7Qd+7cYWpqyvLxZ86coaura2f2nr5heHTZk5eBe7Owvl5v8VG5cPF44GQnRPPlY4+9Z8T1+R82w5QuwytJ5E9PrFPCpqYmrly5UjfQdYu0r169qkt5O3/+PN3d3TtBTi8ZIJdj8ipwc9QqyNsvO7cLkK24m8nA8FONEUCT3bA8Aq/uGiCLgFNEkESOAldMScVWeFxZWeHJkyeHC3ShUGB0dNRS8hMEgdOnT9PZ2Vkhi46UOTKsA38cgWLxoC5d23zpOjycgIliFrLxze/cTQebgI9Ogs3iNMj4+Dhra2uHB/Ts7CwrKyuWju3u7q6epfPGRaYlkRtTRlFxmPZgAsZlw4u3FzfbLQK80wuVFdOdn1EUhbGxsbrEMstAl0olfvjhB0vHtrW1MTg4WP0AXUMF7q1ANntQcIrbXnvfezQusmRyhk6gu7tSLnBULNKSyeTBA/3w4UNLT9Dj8XDx4sXaBzl8zAKLi/UVOYJgzAmKIgiCVuM29gJeKsHjRTAbPIMyBIPWrufx48fWJQarsufk5KT5UxNFhoaGTLWBYnMvY5Mzu/SH6hYIQCgEISd4ykfnFUhosLQO8ThYGcXxOCxE4KjJcZda4fdpMNPGFhYWSCQSW3XB63r06OgoVlhgR0cH4XDY9LjVrEgi4aqYwLa/XC6Niyc0PmrWOCtqRBWNZlUjpEEbcBL4qBsuXQIrc66aBrPr5l7tAk5FrWkjDx48OJjQkcvliMViltS3vr4+S9P609PT227CVdYUduvCcLkNOgDHdvyL2yo9QMpBxAFX3jU8vzbvhlevwNT5dY12DUIh83tZXV21pL3brJwolUqZnqizsxOv12uZi+9SgHd4jiAIDA5exNvcCKW8wX2VNKzNGNrIdksCLg3ZI/LeOfjqGyqoUVv/13VYVaG1CvvYqCQdwPHjvcTjL2qOZk3TePHihWn4EM1K7VgsZqrMbYguViyVSpmez+/3G5qC02fo0cl5o6LbDvL2fBcDFjQccY1IRKsA8i4aXzREJvKaMTo2XvlyuQ7Q1E00+g4ej8eSuFaorhmYe7SqqiwsLFjizFbbr6wMs0AggF1X4MWwUUHq24DbJfRvahk5EHPgbTDUvspaqyF7pvMt4Jk3SvLdz8QbgXAf+DsQgZ6eHu7du1fzetPpNOvr6zXzU02gM5kMmZ3yWUU7ceKEZZpjJQwFAgEY/d2WPl1D3EcSjchTBlyvOFjFMtgK4DKq0MF/gHzSKJ5UxRg5shtc/j339uDBg5qjsFgsmgJdM3TMzc2ZgtLS0oLdbq+rjDcr3d3pYQPksiZRFeQdd2tAaTxHsaY+IkmvjBkapw/8HYZ86mvdA/KGHT9+3PTrV1ZWatYZohlPNLNIJILNZr1XsmgiagiCgKwqtb24CqnIYcwTmqUkt7tk6ODTNwxvtiDxWgG6lteLtQl+3JTS+f3+ulqqiqbqUcYQJO11yDCKcYN31jYmYrWaYAc30kl8Ckb+11ATTapdMw06m83WnP0XXydpuVwuGhoa6iqjrcwtCnWKtypwPa2wsmJNUQtL4tY8Yz5p5IOVsarHS5JE0EJdXguzqmPeigzocDhwu911gdLR0UEgEKgyCl4hFHI465jdX1I07sYglVot83ETkMPbyiOnuFX8vPyTwdVb36kIdGNjo2nOSiQStLe31we0FWXK7XbX1eCt63rteDf2ypiMtnDKAvBMMaa9VBWKhJAxH4WdYYMhbppd3KKIC4/A4TOS4646wcrIrYWZWIsbmpnVSnB7oqsnuVX1YuD/ZmBsTCuLSRkm0U09OhQyNJKKFHED/dlhoxqtMHrNkn4ul6sf6Fof2h6jD9QcPtNYPApcewI7ncdeVTfeStxw7sgub94NtojBQlKLe9622+2mqmSt/FP1EZn1zwmCcPAd875WIykV9zpnEbibhL3TlSKrmx+oXC7b7XChG6wuqoivT/E8v0xaMwomr+ThqPPIa7WGVQXayrxgPfzZkjW2Gy1fhbQRN8ultgY8yOwGeWv2Y7k8SZtGpoEMxqy1oXN7vTB0DMJ1hKzpwEOuNuxK8lk4K7Tt+9bEWonrwGKu5auxQXPvVpzYFpNnZ8005I1rSe9gGB9bBbnMxREVnushjhW89BSCvF0I0a64kdC5J8wdvEdbAbHaw1jMLhPLLW/pQIKMV3YTcYeRJRPxqanbyP6qAoqGZheJlapN4G6V/npZ5ZjCQ7fNzUA0SzcaaGJtFqNuU+yAe90eXBtNPhtqIm7EosiMnj54oM3Cgq7re6q8bCnH18s3eRSerpiX7CWBgVgX7fYIEXeYJmcAm7jreyQ7dH0CE1dBK6GqGomEWIWWSNtEPRsldJQ2kZO9fXSvzhgV36an7or76i52Y1O4f8LLC6e9eibWOHigHQ6HqdK2WyD63cofeRqewa4JBEtObOXhXEInKxZISUXutUxwD2PJRTDTwIfKGXr9J3Bs73/2RiB6CaZvoBU1FEWrGCy2mxMRtVuFAbBlvPDWZ7D0DJZGDIGqmkztzPM86mHc3kxRrI7kWilrYWpmH0Bbqfi2S6gr+ThPm2dwqQInaEK37w4rHgRVIF8qkRLyrEt54u40v3HfxJe/yweZ0/QFu3HbygAGooYOPfMdmrabATn3srMWiUx/EQSwizYj3kdOQbiPxMooqv0ajekMJTesOj2s642s6S4WXV5T8q4WdJKKhrNUO+zVYiVVgbZSCW0vavKlPMgg6wK6rXLs1iUdhyThwEMTHooFjXlbkqQzx1fO7/iDcpcPVk4zEHobr+yB4HHwhGHxFkZPUw0KftbGmmA8EKdt60GMpmb4r8bbKDaZgLOZdgLocn0xYE5KQB6imsdUfKobaCtLeXO5HKVSCZvNRqPDOD4jqQiqgC6ZsxbZIXIMP3pBYFFMEpezfNt8j+8Kz/hl6gI9gRPUKDG2XSzYJRt50RjbPrsXVde4u/SQ3zcZKxFaFRchuQFdqA/kVKFA0qHRkjavgn0+X/30zkqvQj6fJ1tuNfLKHi4s9qIKAgk1U9fNCA6dI7KXvlKE5qKdlCPHfzRe438Wr5LUamd6vUw+tPLQb0l5ERH4v/nb/L5pGJum01VoJGj3oAv1Nc6qBZ05OQkavL1mzqFrKXzi6+gYuVxuR/g4E+g3hpqcQi/Uz7EFWadF9vFWIYBdE3gUnuafxP+s+Zlp1ncssmrKB7i6eJM/RZ5h03TeKjbhcuxjOwlFZFxeoSQKfLF20VSbB2quT6ypk5l1t2uaRiKR2Kzxw+4mfp14D12QmJTjUNrf1g0Oh0SP3kRL0YmCzve8rI4HOk4kioIRNp42zzAcGcem6fSoYSSHsC+QR2wxSqLAR7FTtKlhU0nC5/PVTIY1kWhtbTW9pvn5+R1zZadD/VxY7CUvqkyISwjF/YGtSzrNcgNdaiMSOiNU18c92FC2cS+bptNbakGQ6181ohb0TZDPL77F+y1DlpruQ6FQTcm4JgpHjhwxF2Di8c04DSAJIp9E3uPUUid5EZ5LsX2FkU22LMn0EsaOwAhrJCsCLZMXjeJJ0FXeKjaBvf7qIlMoMmJfoiQKvLfYx6eRD0Az2pXNrKmpaf8e7XA4LLGPkZGRnWxCkvm8+QMGl45TEgVG7EsUCvtn+wI6x2nECcyzhr6ndJEplEPHsWKg7nAh6ALLxTTTjnV0QeKXK+f5pPV9ZElmdHTUQqgzx0k0U+esePWLFy92eDWA2+bir8Mf81HsFKogMO5IECsm0dX9e3cUP05gtBxGNsKJXbDRXvLTVWikoY7WBwChKDKrJojJeewlgb9L/4J3W84gCSLFYtHSxgE+n68mtavJo8GYwgmHw5a247l//z6XLl3a49kfHHmXcCLEl65bLNsVEtoSnYUgDodFbdcGDIKtaFzqCcKMCLFNkJ26hO7Qy+eT6vLi9WKOOTmFKggEsw38rfgLjjRuaX3j4+OmfSiGShg27dSyWYk9Xq/XdFY8FouxtLS0p1tHEkT6gt20FSLcjN3hXssE444EgaJMK35rCat5p6B0rOBn0mFUip6izVJNszvhzdgSZOwqIHBhsZeLzWfx2Rt2yAtWFkWJomipwcYUaFmWaWtrMwW6VCoxMjJCMBisqPw1Onz81ZHLHE8c5UvXLRL2Imv6Ik1FF2Ea62IILoeMR5XISCoevQ6UFZGYsMayw6Bqrckgn4rv0tnWsUeZfPnyJesWlom1tbVZ0oUsrTNUFIWvvvrK0vYQ7777rmlnz3ohyf2VJ9yIPN5kCsGSm4jmQ3BUuJxV9ihnOgIpcjTiIisruH32imW/qIlkigWWbBlSUmlTrv1k7RyDTf07VcOyJRIJvv32W0uTH7/61a8s6UKWF3Q+f/6cR48eYWUEfP7555baXeP5BI/iI1xv2TqvR5UIqA4aBY/h5SXgGmgpreJkREovMBNK4/wAjhYD2Mr5XaFEWiywKuUoicImwBdXBzgZ7KHJGaw6Mr/++mtLXQBdXV0MDQ1ZzAl1rJz98ssv97CLairWF198YXlErxeSPE2McbPxEXl7cQfoDZqMfFXEkZGxIZBHpUAJOxJubLxgjXwAuFydQ51a6qTH0clxXwdOW+0J5evXr7O4uGgec202PvvsM8stF3UBPTc3x61btywde+TIEd5///26Zo6LapG5zCJzmUUeu8aJeVOGR38LZHZza5VuQoyyhi/g4tOz51nJx1HK81IuwUmTM0DE3UzQaS6Q6brOkydPePbsmaVr7e3tZWBgwHIDUV1Al0olvvvuO0vtvGD0Fp85c2Zf21WqukY8nyCppHl+8/HmJEMClRgpmrEjIbFIjouBTi5fvvxae5GOjY3xww8/WIrLHo+Hy5cvWwqPlgqWSsOlr6/P8g1NTExw9+7dfd24JIg0u0K0OyM74zopbOiEcBMnz0HYkydPLIMMcOrUqbpArhvoDc21p6fH8vHT09PcuHGDg7IiEMCBXlbu2nm9rdMePHjA06dPLYMcjUbp6Oio+3v2Ja319/dbKs03bGFhgatXr1ripbVskrVNb14oy0sN+zxXNptleHiYsbExy5/x+/2cP39+X9+3771+L168SCgUsnz86uoqN27c2NemgxvetuHNKpBEI4h7x/tW7dWrV9y6dWvbekcLRZLLxYULF/bdNLTvni5Zljl37hw3b960tKBow4sePHjAy5cvGRoasqQMCoKA3+/nvn0eQVBpwc9Eefl8Dy3oum55q+JCocD9+/eZn5+vax8oQRA4e/bsa22J/Nq7hMViMW7fvm1hycRe6+7upr+/H5vNVpWZzGUW+Rf5txQl6CoYNzrpWOd4PMzfh369twFnl21sWz85OcmjR4/2tU/q0NAQXV1drxX2DmTfu/n5eb7//vt97eAoiiInTpygra0Nn8+3tedSuZD559JvSDpztCtuAkIDzyVj9uMf07+kq/FYTdkglUoRi8UYGxuzpMJVurYzZ85w4sQJdF1/rV7DA9vJcXl5me+//95yGKl0U4FAgEAgQHNzM86Qm98q15j3xQkUZdpFP+PCMnkRLiz28mnrB0i7Frvk83ni8TjLy8vE43HW1tb2vX2nJEkMDQ0d2B6lB7o36fr6Ordu3bKkE5iBPi7FKcrgaxQ51hhi1pNgzVGiR2rnI+EdVFVFURQymQzJZHITVFVVX3sbZUEQ+PDDD4lEIgdGSw98t11FUbh+/bql6flqtiHqR3Dhx8EqWZZRaMFPgMM1j8fDxx9/XPdqsx8d6A17/Pgx4+PjdSXJKdZR0JHQieJHRiBGhgRFvLho43D35O/s7GRwcLCulcA/OdAbcfvhw4emGxFOsrbZohxApqW8ROIl6+TQDx1kj8fD4OAgR44c+fPaET1VzDCV3Gp6KSVKTD0Y3Wy02RCGtitxTbgIlQuQPBqzrKMi0Mvh7r3f09NDf3//of84zqEA/W/L/81UcNey3xLwAGOPhwLY0GnEjg83jnJPlwrMkyJTnk45LJBlWSYQCDA4OGipx/Ag7MB/WWg5t8pUcAmXKhBSdzaLO07J2Hts2GYk9AWN0nqpIsCt+PEdUoiIRCIcPXp035u5/myAVsubmIiIBOQKHZwOoF+n+JbK2lqexMsCyisdtMMDOBKJ0NnZSSgUwuVy/SQ/53TgoaOgKvxr8rfM++I4NfCoMq7yTHVBKJEXNXJCcXMeD6B9LcTFwmmSM6ssLCy89m8ESJJEOBymo6OD1tbWQ2ERP4sYvZxb5Q+p7xgNvap6zKmlTjrlNto8EZpdO1XATCZDIpFgfX2ddDpNLpdDUZQdP7W38RN7Npttc5cFr9dLIBD4yX4P6yejd4nCOkklxZqSRESkwebGJbvw2Ru21qrUE5ZUdQfQP+ffL/xRgX5j22SFNxC8AfoN0G/sDdA/W/t/Ez3Z0KsLHbwAAAAASUVORK5CYII=";

    };

    static getImgNotFoundSrc() {

        return "data:image/png;base64,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";

    };

    static getPageOrientation(chartCounter, maxChartPerPage = 2) {

        return (chartCounter > maxChartPerPage) ? 'H' : 'L';

    }

    static createReportHeadlineFromParams(params) {

        let headlineParts = [];

        if (params['location'] !== undefined)
            headlineParts.push(StaticFunctions.createReportHeadlineLocation(params['location'], params['locationTitle'], params['allLocationsTitle']));

        if (params['machine'] !== undefined)
            headlineParts.push(StaticFunctions.createReportHeadlineMachine(params['machine'], params['machineTitle'], params['allMachinesTitle']));

        if (params['machines'] !== undefined)
            headlineParts.push(StaticFunctions.createReportHeadlineMachines(params['machines'], params['machinesTitle']));

        if (params['operator'] !== undefined)
            headlineParts.push(StaticFunctions.createReportHeadlineOperator(params['operator'], params['operatorTitle'], params['allOperatorTitle']));

        if (params['design'] !== undefined)
            headlineParts.push(StaticFunctions.createReportHeadlineDesign(params['design'], params['designTitle'], params['stitchesUnit'], params['allDesignsTitle']));

        if (params['firstDesign'] !== undefined)
			headlineParts.push(StaticFunctions.createReportHeadlineDesign(params['firstDesign'], params['firstDesignTitle'], params['stitchesUnit'], params['allDesignsTitle']));

        if (params['secondDesign'] !== undefined)
			headlineParts.push(StaticFunctions.createReportHeadlineDesign(params['secondDesign'], params['secondDesignTitle'], params['stitchesUnit'], params['allDesignsTitle']));

        if (params['fixTimerange'] !== undefined) {
            headlineParts.push(StaticFunctions.createReportHeadlineDefaultPart(params['fixTimerange'], params['timerangeTitle']));
        } else if (params['timerange'] !== undefined && params['formatedDate'] !== undefined)
            headlineParts.push(StaticFunctions.createReportHeadlineTimerange(params['timerange'], params['formatedDate'], params['timerangeTitle']));

        if (params['shift'] !== undefined)
            headlineParts.push(StaticFunctions.createReportHeadlineShift(params['shift'], params['shiftTitle']));

        if (params['groupingOpt'] !== undefined && params['groupingId'] !== undefined)
            headlineParts.push(StaticFunctions.createReportHeadlineGrouping(params['groupingOpt'], params['groupingId'], params['groupingTitle']));

        if (params['overview'] !== undefined)
            headlineParts.push(StaticFunctions.createReportHeadlineDefaultPart(params['overview'], params['overviewTitle']));

        if (params['custom'] !== undefined)
            headlineParts.push(params['custom']);

        headlineParts = headlineParts.filter(part => part.length > 0);

        return headlineParts.join(' | ');

    }

    static createReportHeadlineDefaultPart(value, valueTitle = null) {

        return (value) ? ((valueTitle) ? valueTitle + ': ' : '') + value : '';

    }

    static createReportHeadlineLocation(location, locationTitle = 'Location', allLocationsTitle = 'All Locations 2') {

        if (!location) return '';
        if (location.id === 0) return allLocationsTitle;

        return ((locationTitle) ? locationTitle + ': ' : '') + location.name;

    }

    static createReportHeadlineMachine(machine, machineTitle = 'Machine', allMachinesTitle = 'All Machines') {

        if (!machine) return '';
        if (machine.value === 'all') return allMachinesTitle;

        return ((machineTitle) ? machineTitle + ': ' : '') + machine.label;

    }

    static createReportHeadlineMachines(machines, machineTitle = 'Machines') {

        const machineNames = machines.map(
            (machine) => {
                return machine.label;
            }
        );

        return (machineNames.length > 0) ? machineTitle + ': ' + machineNames.join(', ') : '';

    }

    static createReportHeadlineOperator(operator, operatorTitle = 'Operator', allOperatorTitle = 'All operator') {

        if (!operator) return '';
        if (operator.value === 'all') return allOperatorTitle;

        return ((operatorTitle) ? operatorTitle + ': ' : '') + operator.label;

    }

    static createReportHeadlineDesign(design, designTitle = 'Design', unit = 'Stitches', allDesignsTitle = 'All Designs') {

        if (!design) return '';
        if (design === 'all') return allDesignsTitle;

        return ((designTitle) ? designTitle + ': ' : '') + design.id + ' (' + StaticFunctions.formatedNumber(design.stitches) + ' ' + unit + ')';

    }

    static createReportHeadlineTimerange(timerange, formatedDate = 'MM-DD-YYYY', timerangeTitle = 'Timerange') {

        if (!timerange) return '';

        return ((timerange.getFromMoment()) ? timerangeTitle + ': ' + timerange.getFromMoment().format(formatedDate) : '') + ((timerange.getTillMoment()) ? ' - ' + timerange.getTillMoment().format(formatedDate) : '');

    }

    static createReportHeadlineShift(shift, shiftTitle = 'Shift') {

        return ((shift && shift.id !== 0) ? shiftTitle + ': ' + shift.name : '') + ((shift && shift.id !== 0 && shift.from && shift.to) ? ' (' + ((shift.from.split(':').length === 3) ? shift.from.slice(0, -3) : shift.from) + ' - ' + ((shift.to.split(':').length === 3) ? shift.to.slice(0, -3) : shift.to) + ' Uhr)' : '');

    }

    static createReportHeadlineGrouping(groupingOpt, groupingId, groupingTitle = 'Grouping') {

        const found = groupingOpt.find(
            (grouping) => {
                return String(grouping.id) === groupingId
            }
        );

        return (found !== undefined) ? groupingTitle + ': ' + found.name : '';

    }

    static reduceStrToUtf8(str, mark = '?') {

        if (!str) return '';
        if (!mark) mark = '?';

        let reducedStr = '';

        for (let i = 0; i < str.length; i++) {
            reducedStr += (str.charCodeAt(i) > 255) ? mark : str.charAt(i);
        }

        return reducedStr;

    }

    static getBtoa(str) {

        str = StaticFunctions.reduceStrToUtf8(str);

        return (str) ? btoa(str) : '';

    }

    static getMachineHeads(machine) {

        if (!machine) return 1;

        if (machine.heads_manually_overwritten > 0) return machine.heads_manually_overwritten;
        if (machine.heads > 0) return machine.heads;
        if (machine.w_heads_detected > 0) return machine.w_heads_detected;
        if (machine.k_heads_detected > 0) return machine.k_heads_detected;

        return 1;

    }

    static getStatusSerialColors() {

        return {
            status_1001: {color: "#AAAAAA", statustext: "Maschine ausgeschaltet"},
            status_1011: {color: "#38D620", statustext: "Maschine gestoppt Mustercode STOP"},
            status_1012: {color: "#E09F28", statustext: "Maschine gestoppt am Musterende"},
            status_1013: {color: "#28E0BB", statustext: "Maschine gestoppt Mustercode"},
            status_1014: {color: "#FF59AC", statustext: "Maschine gestoppt per Schaltstange"},
            status_1015: {color: "#5BFF61", statustext: "Maschine stickt"},
            status_1016: {color: "#B78B8B", statustext: "Maschinen-Stillstand"},
            status_1017: {color: "#87FFCF", statustext: "Nadelwechsel"},
            status_1018: {color: "#C9FF87", statustext: "Fadenschneiden"},
            status_1019: {color: "#77A0FF", statustext: "Muster bereit"},
            status_1020: {color: "#FFFF7F", statustext: "Warten auf neues Muster"},
            status_1021: {color: "#3DFFDB", statustext: "Tischplattenbetrieb möglich"},
            status_1022: {color: "#FF0000", statustext: "Maschine gestoppt durch Fehler"},
            status_1023: {color: "#87FF66", statustext: "Farbwechsel"},
            status_1024: {color: "#3E9125", statustext: "Spulenkapselwechsel"},
            status_1025: {color: "#40BC1E", statustext: "Spulenkapselwechslermagazin wechseln"},
            status_1064: {color: "#B477FF", statustext: "Hauptwelle nicht OT"},
            status_1065: {color: "#FF9077", statustext: "Farbwechselstart = F1"},
            status_1066: {color: "#FF4747", statustext: "Fadenbruch"},
            status_1067: {color: "#4B50E5", statustext: "keine Druckluft"},
            status_1068: {color: "#FF6100", statustext: "keine Musterdaten verfügbar"},
            status_1069: {color: "#FF00C3", statustext: "Pailetten nicht verfügbar"},
            status_1070: {color: "#CECCCC", statustext: "Rahmenbegrenzung"},
            status_1071: {color: "#FF7B5E", statustext: "Stromunterbrechung"},
            status_1072: {color: "#D1FCE1", statustext: "Start Tischplattenbetrieb = F1"},
            status_1073: {color: "#FFF83D", statustext: "Pantograph nicht hinten"},
            status_1074: {color: "#E8C900", statustext: "Pailetten Endlage?"},
            status_1075: {color: "#FF008C", statustext: "Bohrer nicht verfügbar"},
            status_1076: {color: "#FF4800", statustext: "PA-Handverstellung ist nicht aktiviert"},
            status_1077: {color: "#0E00D3", statustext: "Nadel gesperrt"},
            status_1078: {color: "#06007C", statustext: "Kopfart gesperrt"},
            status_1079: {color: "#5E2E46", statustext: "Maschine gestoppt durch Lichtschranke"},
            status_1080: {color: "#0083FF", statustext: "Spulenkapselwechsler: Magazinwechsel erforderlich"}
        };

    }

    static getStatusTypeColors() {

        return {
            ok: {
                color1: '#009036',
                color2: '#003714',
                color3: '#004B1C',
            },
            error: {
                color1: '#FF0000',
                color2: '#D40000',
                color3: '#A60013',
            },
            switchoff: {
                color1: '#0392B7',
                color2: '#03385F',
                color3: '#05548E',
            },
            warning: {
                color1: '#FF5400',
                color2: '#B34800',
                color3: '#993D00',
            },
        };

    }

}

export default StaticFunctions;